import request from '@/utils/request'


// 查询择医记录列表
export function listChoose(query) {
  return request({
    url: '/user/choose/list',
    method: 'get',
    params: query
  })
}

// 查询择医记录分页
export function pageChoose(query) {
  return request({
    url: '/user/choose/page',
    method: 'get',
    params: query
  })
}

// 查询择医记录详细
export function getChoose(data) {
  return request({
    url: '/user/choose/detail',
    method: 'get',
    params: data
  })
}

// 新增择医记录
export function addChoose(data) {
  return request({
    url: '/user/choose/add',
    method: 'post',
    data: data
  })
}

// 修改择医记录
export function updateChoose(data) {
  return request({
    url: '/user/choose/edit',
    method: 'post',
    data: data
  })
}

// 删除择医记录
export function delChoose(data) {
  return request({
    url: '/user/choose/delete',
    method: 'post',
    data: data
  })
}

export function allotChoose(data) {
  return request({
    url: '/user/choose/allot',
    method: 'post',
    data: data
  })
}

export function allotDetail(query) {
  return request({
    url: '/user/choose/allotDetail',
    method: 'get',
    params: query
  })
}

// 根据择医条件筛选医师列表
export function selectDoctorByChoose(query) {
  return request({
    url: '/user/choose/selectDoctorByChoose',
    method: 'get',
    params: query
  })
}


